<template>
    <ValidationProvider :name="name" :rules="field._validation" v-slot="validator">
        <b-field>
            <EvoLabel slot="label" :name="name" :field="field" :validator="validator"></EvoLabel>
            <b-select v-model="value" @input="otherDatasToSet" :placeholder="field._placeholder" >
                <option v-for="(option,key) in field._options" :value="option._value" :key="key">
                    {{ option._display }}
                </option>
            </b-select>
        </b-field>
        <EvoError v-if="validator.errors[0]" :validator="validator"></EvoError>
    </ValidationProvider>
</template>

<script>
import mixin from "./mixin";
import option_mixin from "./option_mixin";

export default {
    mixins: [mixin, option_mixin],
}
</script>
